import * as React from 'react';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    title: string,
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const {children, onClose, title, ...other} = props;

    return (
        <DialogTitle sx={{m: 0, p: 2}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

interface DialogProps {
    IsOpen: boolean,
    title: string,
    body: any,
    confirmButton: any,
    handleClose: () => void;
}

const BootStrapDialog: React.FC<DialogProps> = ({IsOpen, title, body, confirmButton, handleClose}) => {

    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                fullWidth={true}
                aria-labelledby="customized-dialog-title"
                open={IsOpen}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} title={title}>
                    {title}</BootstrapDialogTitle>
                <DialogContent dividers>
                    {body}
                </DialogContent>
                <DialogActions>
                    {confirmButton}
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}

export default BootStrapDialog;